module.exports = __webpack_public_path__ + "media/components/Sponsors/Projects/Shared/MulchStepForm/question-410f053d72e9686ca0b7c8becc1c1258.png";